import React from 'react';

export function Spinner({ size = 14 }) {
  return (
    <span
      className="inline-block shrink-0 rounded-full border-2 border-rule border-t-signal animate-spin"
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
}

export default function Loading({ label = 'Loading', className = '' }) {
  return (
    <div role="status" className={`flex items-center gap-2 px-4 py-10 text-body text-graphite ${className}`}>
      <Spinner />
      {label}…
    </div>
  );
}

const WIDTHS = ['72%', '45%', '88%', '60%', '38%', '80%', '52%'];

// Placeholder rows in the shape of the table they stand in for.
export function SkeletonRows({ rows = 8, columns }) {
  return Array.from({ length: rows }, (_, row) => (
    <tr key={row} aria-hidden="true">
      {Array.from({ length: columns }, (__, col) => (
        <td key={col} className="h-9 px-3 border-b border-rule">
          <div className="h-2.5 rounded-badge bg-rule skeleton" style={{ width: WIDTHS[(row + col * 3) % WIDTHS.length] }} />
        </td>
      ))}
    </tr>
  ));
}
